module.exports = __webpack_public_path__ + "media/primer_escudo_v2.20126c0b.mp4";